/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

export const Description = styled('p')({
  color: 'black',
});
